<template>
<main id='app'>
	<router-view/>
</main>
</template>


<script>
import Events from './events'

export default {
	name: 'App',
	watch: {
		'$route'(to, from) {
			// ga('send', 'event', 'link', to.name.toLowerCase())
		}
	},
}
</script>


<style lang='less'>
@import './styles/normalize.less';
@import './styles/variables.less';

body {
	background-color: #000;
}

#app {
	max-width: 100%;
	max-height: 100%;
	font-family: @font-default;
	color: #FFF;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	overflow: hidden;
	opacity: 0;
	animation: fade-in .4s forwards;
}

@keyframes fade-in {
	to {
		opacity: 1;
	}
}

.center {
	position: relative;
	width: 100%;
	max-width: 1380px;
	padding: 0 30px;
	margin: auto;
	box-sizing: border-box;
}

p, h1, h2, h3, h4 {
	margin: 0;
	font-weight: 400;
}

</style>



// WEBPACK FOOTER //
// src/App.vue